module.exports = __webpack_public_path__ + "img/Archives.324ace44.svg";